import { Field, ErrorMessage } from 'formik';
import React from 'react';
import TextError from '../TextError';
import CustomDropdown from '../../UI/Dropdown';
import { getErrorMessage } from '../../../utils/helpers';

const CustomReactSelect = (props) => {
  const {
    label,
    name,
    className,
    style,
    labelClassname,
    id,
    type,
    value,
    height,
    placeholderMarginTop,
    placeholder,
    placeholderColor,
    options,
    menuWidth,
    border,
    onChangeAction,
    wrappedStyles,
    isMulti,
    isDisabled,
    ...rest
  } = props;
  return (
    <div style={wrappedStyles}>
      <Field name={name} id={id} validate={rest.validate || false}>
        {(formik) => {
          const {
            field: { value, name },
            form: { setFieldValue, setTouched, touched, errors },
          } = formik;
          return (
            <div>
              <label className={labelClassname}>
                {label}
                {rest.isRequired ? (
                  <span className="text-danger">*</span>
                ) : null}
              </label>
              <CustomDropdown
                style={style}
                id={id}
                onChange={(value) => {
                  setFieldValue(name, value, false);
                  onChangeAction ? onChangeAction(value) : null;
                }}
                options={options}
                isSearchable={false}
                height={height}
                placeholderMarginTop={placeholderMarginTop}
                placeholder={placeholder}
                placeholderColor={placeholderColor}
                value={value}
                menuWidth={menuWidth}
                border={border ? border : '1 px solid #9aa5ad'}
                onBlur={() => {
                  setTouched({ ...touched, [name]: true });
                }}
                isMulti={isMulti}
                isDisabled={isDisabled}
                {...rest}
              />
              {/* {touched[name] && errors[name] && (
                <TextError>{errors[name]}</TextError>
              )} */}
              <ErrorMessage component={TextError} name={name} />
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default CustomReactSelect;
